<template>
  <div
    v-if="filteredNotifications.length"
    :class="['flex flex-col gap-3', outerClass]"
    :style="inlineStyle"
    :data-test-id="dataTestId"
  >
    <Notification
      v-for="(notification, index) in filteredNotifications"
      :key="index"
      :type="notification.fields?.type?.value"
      :title="notification?.fields?.title?.value"
      :description="notification?.fields?.content?.value"
      :fullWidth="true"
      :openByDefault="notification?.fields?.openByDefault?.value"
    />
  </div>
</template>

<script lang="ts" setup>
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import Notification from '../Notification/Notification.vue';
import { useAccountStore, usePageStore } from '@/store';
import { computed } from 'vue';

const props = defineProps<{
  fields: ComponentFields;
  rendering: ComponentRendering;
}>();

const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);

/**
 * Filter notification by relevant products
 */
const accountStore = useAccountStore();
const filteredNotifications = computed(() => {
  return (props.fields.Notifications as Item[])?.filter((notification) => {
    if (
      /** Show if is for insurance AND member has insurance */
      (notification.fields?.forInsurance?.value &&
        accountStore.identityDetails?.portfolio?.insurancePolicies?.length) ||
      /** OR Show if is for roadside and member has roadside */
      (notification.fields?.forRoadside?.value &&
        accountStore.identityDetails?.portfolio?.assistanceProducts?.length) ||
      /** OR Show if is for bank and member has bank */
      (notification.fields?.forBank?.value && accountStore.identityDetails?.portfolio?.bankingProducts?.length)
    ) {
      return true;
    }

    // also show if none checked
    return (
      !notification.fields?.forBank?.value &&
      !notification.fields?.forRoadside?.value &&
      !notification.fields?.forInsurance?.value
    );
  });
});
</script>
